import { render, staticRenderFns } from "./ParaCRCard.vue?vue&type=template&id=3394bd5d&scoped=true&"
import script from "./ParaCRCard.vue?vue&type=script&lang=js&"
export * from "./ParaCRCard.vue?vue&type=script&lang=js&"
import style0 from "./ParaCRCard.vue?vue&type=style&index=0&id=3394bd5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3394bd5d",
  null
  
)

export default component.exports